module.exports = __webpack_public_path__ + "img/hk.7667be2e.svg";